export enum NavigationEvent {
  OPEN_HAMBURGER_MENU = 'OpenHamburgerMenu',
  HEADER_LINK_CLICK = 'HeaderLinkClickEvent',
  FOOTER_LINK_CLICK = 'FooterLinkClickEvent',
  CHANGE_LANGUAGE = 'ChangeLanguageEvent',
  BACK_TO_TOP = 'BackToTop',
  GO_TO_WINNERS = 'GoToWinners',
}
